import { cn } from "../utils/utils";

interface LoaderSpinnerProps {
	className?: string;
	size?: number;
	borderColor?: "primary" | "white";
}

export const LoaderSpinner = ({
	className,
	size = 8,
	borderColor = "primary",
}: LoaderSpinnerProps): JSX.Element => {
	const borderColorClasses = {
		primary: "border-primary border-e-transparent",
		white: "border-white border-e-transparent",
	};

	return (
		<div className={cn("text-center", className)}>
			<div
				role="status"
				className={cn(
					`inline-block h-${size} w-${size} animate-spin rounded-full border-4 border-solid align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]`,
					borderColorClasses[borderColor]
				)}
			>
				<span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
					Loading...
				</span>
			</div>
		</div>
	);
};
